import React from "react";
import WorshipArticleLayout from "./WorshipArticleLayout";
import {SeoHelper} from "../../components/helpers/SeoHelper";

const IWantToWorship = () => {
    return (
        <WorshipArticleLayout
            title="I Want to Worship"
            subtitle="If you long to worship God but aren’t sure where to begin, you are not alone. Many people want to worship faithfully — they just need a starting point."
            secondaryCta={{
                title: "Not sure where to begin?",
                text: "Many worship leaders and individuals find that beginning with Scripture helps worship take shape naturally, without forcing it.",
                label: "Worship Songs by Bible Passage",
                href: "/worship/worship-songs-by-bible-passage"
            }}
            primaryCta={{
                title: "Begin with Scripture",
                label: "Start with a Bible Passage",
                href: "/scripture/choose-song-book"
            }}
        >
            <SeoHelper
                uri = "/worship/i-want-to-worship"
                title = "I want to worship | The Worship Bible"
                description="If you long to worship God but aren’t sure where to begin, you are not alone. Many people want to worship faithfully — they just need a starting point."
            />

            {/* Intro anchor */}
            <p className="article-intro">
                Worship does not begin with music, a stage, or a plan.  Worship begins with a heart turned toward God.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">What Does It Mean to Worship?</h2>
            <p>
                Biblical worship is a response to who God is and what He has done. Throughout Scripture, worship flows naturally from encountering God’s word (see <a target="biblegateway" href="https://www.biblegateway.com/passage/?search=Psalm%2095%3A1%E2%80%937&version=NIV">Psalm&nbsp;95:1–7</a>; <a target="biblegateway" href="https://www.biblegateway.com/passage/?search=Romans%2012%3A1&version=NIV">Romans&nbsp;12:1</a>).
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Worship Can Begin in Many Ways</h2>
            <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal">
                <li><strong>Through Scripture</strong>, hearing God speak</li>
                <li><strong>Through song</strong>, giving voice to faith</li>
                <li><strong>Through prayer</strong>, offering ourselves to God</li><li><strong>Through silence and reflection</strong>, learning to listen</li>
            </ul>

            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">Starting with Scripture</h3>
            <p>
                When worship begins with Scripture, songs and prayers take on deeper meaning. Scripture provides both direction and freedom — it gives worship a centre, not a script.
            </p>

            <p>
                The Worship Bible helps connect passages of Scripture directly to worship songs that reflect their themes, allowing worship to grow naturally from God’s word.
            </p>

        </WorshipArticleLayout>
    );
};

export default IWantToWorship;